var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyFaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Checked_24",
    width: 100,
    height: 100,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.25 0 0 0.25 12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(186,224,189)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-40, -40)",
    d: "M 40 77.5 C 19.3 77.5 2.5 60.7 2.5 40 C 2.5 19.299999999999997 19.3 2.5 40 2.5 C 60.7 2.5 77.5 19.3 77.5 40 C 77.5 60.7 60.7 77.5 40 77.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(94,156,118)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-40, -40)",
    d: "M 40 3 C 60.4 3 77 19.6 77 40 C 77 60.4 60.4 77 40 77 C 19.6 77 3 60.4 3 40 C 3 19.6 19.6 3 40 3 M 40 2 C 19 2 2 19 2 40 C 2 61 19 78 40 78 C 61 78 78 61 78 40 C 78 19 61 2 40 2 L 40 2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.35 -0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-41.35, -39.7)",
    d: "M 34 56 L 20.2 42.2 L 24.5 38 L 34 47.6 L 58.2 23.4 L 62.5 27.6 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFaceIcon);
export default __webpack_public_path__ + "static/media/happy-face-icon.2fd839cf712f227c69d000ef35b3857a.svg";
export { ForwardRef as ReactComponent };